import _ from "lodash";
import { APP_VERSION_RESTAURANT } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        appVersionRestaurant: _.cloneDeep(constants.APP_VERSION_RESTAURANT_INPUT)
    }
}

const appVersionRestaurantReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case APP_VERSION_RESTAURANT.SET_APP_VERSION_RESTAURANT_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case APP_VERSION_RESTAURANT.SET_APP_VERSION_RESTAURANT:
        case APP_VERSION_RESTAURANT.SET_APP_VERSION_RESTAURANT_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    appVersionRestaurant: action.appVersionRestaurant
                }
            })
        default:
            return state
    }
}

export default appVersionRestaurantReducer